import { AcmidmAuthService } from '@anb/ng-auth';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loggedout',
  templateUrl: './loggedout.component.html',
})
export class LoggedOutComponent implements OnInit {
  constructor(private authService: AcmidmAuthService) {}

  ngOnInit(): void {
    this.authService.clear();
  }
}
